import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { Link } from "react-router-dom";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import RentalCarousel from "../components/RentalCarousel";
import "./locationVehicules.css";
import FaqSectionL from "../components/FaqSectionL";
import { Helmet } from "react-helmet";

export default function LocationVehicules() {
  const [vehicules, setVehicules] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [filter, setFilter] = useState({ carburant: "", transmission: "" });
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchVehicules = async () => {
      const vehiculeSnap = await getDocs(
        query(
          collection(db, "vehicules_auto"),
          where("location.estDisponible", "==", true),
          where("statut", "==", "disponible")
        )
      );

      const vehicules = await Promise.all(
        vehiculeSnap.docs.map(async (docSnap) => {
          const vehicule = { id: docSnap.id, ...docSnap.data() };

          const resSnap = await getDocs(
            query(
              collection(db, "reservations"),
              where("vehicleId", "==", vehicule.id),
              where("statut", "==", "validée")
            )
          );

          const now = new Date();

          const isOccupe = resSnap.docs.some((rDoc) => {
            const r = rDoc.data();
            const dateFin =
              r.prolongationDemandee && r.nouvelleDateFin
                ? new Date(r.nouvelleDateFin)
                : new Date(r.dateFin);

            return now <= dateFin;
          });

          return !isOccupe ? vehicule : null;
        })
      );

      const filteredVehicules = vehicules.filter((v) => v !== null);
      setVehicules(filteredVehicules);
      setFiltered(filteredVehicules);
    };

    fetchVehicules();
  }, []);

  useEffect(() => {
    const results = vehicules.filter(
      (v) =>
        (!filter.carburant ||
          v.ficheTechnique?.carburant === filter.carburant) &&
        (!filter.transmission ||
          v.ficheTechnique?.transmission === filter.transmission) &&
        (!search ||
          `${v.marque} ${v.modele}`.toLowerCase().includes(search.toLowerCase()))
    );
    setFiltered(results);
  }, [filter, search, vehicules]);

  if (vehicules.length === 0 && filtered.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Location de Voitures en Afrique | Réservez en ligne avec
          TheBridgeOfWorld
        </title>
        <meta
          name="description"
          content="Louez une voiture neuve ou d’occasion à prix compétitif. Réservation simple, livraison rapide, véhicules fiables en Afrique – The Bridge of World."
        />
        <meta
          name="keywords"
          content="location voiture Afrique, louer voiture Togo, location SUV, berline, utilitaire, The Bridge of World"
        />
        <meta name="author" content="The Bridge of World" />
        <meta
          property="og:title"
          content="Location de Voitures en Afrique | TheBridgeOfWorld.com"
        />
        <meta
          property="og:description"
          content="Réservez votre véhicule à louer facilement en ligne. Livraison rapide, prix transparents, qualité garantie."
        />
        <meta
          property="og:url"
          content="https://thebridgeofworld.com/locations"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="The Bridge of World" />
        <meta
          property="og:image"
          content="https://thebridgeofworld.com/images/og-location.jpg"
        />
      </Helmet>

      <MenuNav />
      <MobileMenu />
      <RentalCarousel />

      <div className="container py-4">
        <div className="mb-4 animate__animated animate__fadeIn">
          <input
            type="text"
            className="form-control form-control-lg search-input-animated"
            placeholder="🔍 Rechercher un véhicule (ex: Toyota, Hilux...)"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <nav aria-label="breadcrumb" className="mb-4">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Accueil</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Véhicules à louer
            </li>
          </ol>
        </nav>

        <div className="row">
          <div className="col-md-3 mb-4">
            <div className="border rounded p-3 shadow-sm bg-white">
              <h6 className="fw-bold mb-3">Filtres</h6>

              <label className="form-label">Recherche</label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Rechercher marque, modèle..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              <label className="form-label">Carburant</label>
              <select
                className="form-select mb-3"
                value={filter.carburant}
                onChange={(e) =>
                  setFilter({ ...filter, carburant: e.target.value })
                }
              >
                <option value="">Tous</option>
                <option value="Essence">Essence</option>
                <option value="Diesel">Diesel</option>
                <option value="Électrique">Électrique</option>
              </select>

              <label className="form-label">Transmission</label>
              <select
                className="form-select"
                value={filter.transmission}
                onChange={(e) =>
                  setFilter({ ...filter, transmission: e.target.value })
                }
              >
                <option value="">Toutes</option>
                <option value="Automatique">Automatique</option>
                <option value="Manuelle">Manuelle</option>
              </select>
            </div>

            <div className="sticky-top" style={{ top: "100px" }}>
              <div className="card shadow-sm border-0 mb-4">
                <video
                  src="/assets/JETOUR.mp4"
                  className="card-img-top"
                  autoPlay
                  style={{ objectFit: "cover", height: "300px" }}
                />
                <div className="card-body text-center">
                  <h6 className="fw-bold">🛍️ Offre exclusive</h6>
                  <p className="text-muted small">
                    Découvrez nos véhicules premium disponibles.
                  </p>
                  <Link
                    to="/catalogue"
                    className="btn btn-sm btn-outline-primary rounded-pill"
                  >
                    Choisir
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-9">
            <h2 className="fw-bold mb-4">Véhicules disponibles à la location</h2>

            {filtered.length === 0 ? (
              <p>Aucun véhicule trouvé.</p>
            ) : (
              filtered.map((v) => {
                const whatsappMessage = `Bonjour, je suis intéressé par la location du véhicule ${v.marque} ${v.modele} (${v.annee}). Est-il disponible ?`;

                return (
                  <div
                    className="vehicle-card mb-4 shadow-sm position-relative"
                    key={v.id}
                  >
                    {v.isFeatured && (
                      <span className="badge bg-warning text-dark position-absolute top-0 start-0 m-2">
                        🔥 Populaire
                      </span>
                    )}

                    <div className="row g-0">
                      <div className="col-md-4">
                        <img
                          src={v.imageUrls?.[0]}
                          alt={`${v.marque} ${v.modele}`}
                          className="img-fluid vehicle-image"
                        />
                      </div>

                      <div className="col-md-8 vehicle-body">
                        <h5 className="fw-bold">
                          {v.marque} {v.modele}
                        </h5>
                        <p className="text-muted">
                          {v.description ||
                            "Véhicule disponible à la location"}
                        </p>

                        <p className="fw-bold fs-5 text-success">
                          {v.location?.tarif
                            ? new Intl.NumberFormat("fr-FR").format(
                                v.location.tarif
                              ) + " FCFA / jour"
                            : "Tarif sur demande"}
                        </p>

                        <div className="d-flex flex-wrap gap-2 mt-2 align-items-start vehicle-actions">
                          <Link
                            to={`/vehicules/${v.slug}`}
                            className="btn btn-outline-danger btn-sm"
                          >
                            Détails
                          </Link>

                          <a
                            href={`https://wa.me/${v.contact || ""}?text=${encodeURIComponent(
                              whatsappMessage
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-success btn-sm"
                          >
                            WhatsApp
                          </a>

                          <Link
                            to="/reservation"
                            state={{ vehicule: v }}
                            className="btn btn-primary btn-sm"
                          >
                            Réserver
                          </Link>
                        </div>

                        <div className="d-flex flex-wrap gap-2 mt-3">
                          {v.ficheTechnique?.climatisation && (
                            <span className="badge bg-light text-dark border">
                              Clim
                            </span>
                          )}
                          {v.ficheTechnique?.airbag && (
                            <span className="badge bg-light text-dark border">
                              Airbag
                            </span>
                          )}
                          {v.ficheTechnique?.gps && (
                            <span className="badge bg-light text-dark border">
                              GPS
                            </span>
                          )}
                        </div>

                        <div className="vehicle-specs-wrapper mt-3">
                          <div className="vehicle-specs">
                            {[
                              {
                                icon: "person",
                                label: "Pers",
                                value: v.ficheTechnique?.places,
                              },
                              {
                                icon: "door-closed",
                                label: "Portes",
                                value: v.ficheTechnique?.portes,
                              },
                              {
                                icon: "gear",
                                label: "Transmission",
                                value: v.ficheTechnique?.transmission,
                              },
                              {
                                icon: "currency-dollar",
                                label: "Caution",
                                value: v.location?.caution,
                              },
                              {
                                icon: "fuel-pump",
                                label: "Carburant",
                                value: v.ficheTechnique?.carburant,
                              },
                            ].map((s, i) => (
                              <div className="spec-item" key={i}>
                                <i className={`bi bi-${s.icon}`}></i>
                                <div>
                                  {s.label}
                                  <br />
                                  {s.value || "---"}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      <FaqSectionL />

      <footer
        style={{ backgroundColor: "#0C1E47" }}
        className="text-white pt-5 pb-3 mt-5 border-top"
      >
        <div className="container">
          <div className="row gy-4">
            <div className="col-md-4">
              <div className="logo-wrapper">
                <img
                  src="/BRIDGE BLANC.png"
                  alt="THE BRIDGE logo"
                  width="180"
                  className="mb-3"
                />
              </div>
              <p style={{ color: "#F7931E", fontWeight: 500 }}>
                Let’s connect the world together
              </p>
              <p className="small text-white-50">
                THE BRIDGE est votre partenaire de confiance pour l’achat de
                véhicules fiables à travers le monde.
              </p>
            </div>

            <div className="col-md-4">
              <h6 className="text-uppercase fw-semibold mb-3">Navigation</h6>
              <ul className="list-unstyled">
                <li>
                  <Link to="/" className="text-white-50 text-decoration-none">
                    Accueil
                  </Link>
                </li>
                <li>
                  <Link
                    to="/catalogue"
                    className="text-white-50 text-decoration-none"
                  >
                    Nos véhicules
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-white-50 text-decoration-none"
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <Link
                    to="/mentions-legales"
                    className="text-white-50 text-decoration-none"
                  >
                    Mentions légales
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-md-4">
              <h6 className="text-uppercase fw-semibold mb-3">
                Nous contacter
              </h6>
              <p className="text-white-50 small mb-1">
                <i className="bi bi-geo-alt me-2"></i>Lomé, Togo
              </p>
              <p className="text-white-50 small mb-1">
                <i className="bi bi-envelope me-2"></i>
                contact@thebridgeofworld.com
              </p>
              <p className="text-white-50 small mb-0">
                <i className="bi bi-phone me-2"></i>+228 78 81 54 94 / +228 99
                41 00 41 / +228 93 90 72 95
              </p>
            </div>
          </div>

          <div className="text-center mt-4 pt-3 border-top border-secondary text-white-50 small">
            © {new Date().getFullYear()} THE BRIDGE — Tous droits réservés
          </div>
        </div>
      </footer>

      <a
        href="https://wa.me/22878815494"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Contacter sur WhatsApp"
      >
        <i className="bi bi-whatsapp fs-3"></i>
      </a>
    </>
  );
}
